import Card from "./card.js";
import CardForm from "./form.js";


function App() {
    return (
        <div className="App">
            <div>
                <Card />
                <CardForm />
            </div>
        </div>
    );
}

export default App;
